
function initializeScratchDriveJourney() {
'use strict';

const root=document.getElementById('sd4d-root');
if(!root||root.dataset.initialized)return;
root.dataset.initialized='true';

const config=JSON.parse(root.querySelector('[data-sd4d-config]').textContent);
const products=config.products;
if(!products.length)return;

const ui=config.ui;
const $=id=>root.querySelector('#sd4d-'+id);
const clamp=(v,a=0,b=1)=>Math.max(a,Math.min(b,v));
const lerp=(a,b,t)=>a+(b-a)*t;
const smooth=(a,b,x)=>{
  const t=clamp((x-a)/(b-a));
  return t*t*(3-2*t);
};

// Entfernt sichtbare HTML-Zeilenumbrüche aus den Kapiteltexten.
// Funktioniert auch bei als &lt;br&gt; gespeicherten Zeichen.
function cleanChapterText(value) {
  let result=String(value??'');
  const decoder=document.createElement('textarea');

  for(let i=0;i<2;i++){
    decoder.innerHTML=result;
    result=decoder.value;
  }

  return result
    .replace(/<br\s*\/?>/gi,' ')
    .replace(/\s+/g,' ')
    .trim();
}

const journey=$('reise');
const gallery=$('kollektion');
const viewport=journey.querySelector('.viewport');
const galleryView=gallery.querySelector('.gallery-viewport');

const chapters=[
  {
    at:0,
    title:'',
    sub:'',
    label:'01 / WELTALL',
    coord:ui.start
  },
  {
    at:.36,
    title:ui.swiss_title,
    sub:ui.swiss_sub,
    label:'02 / SWITZERLAND',
    coord:'46°48′ N / 8°13′ E'
  },
  {
    at:.57,
    title:ui.city_title,
    sub:ui.city_sub,
    label:'03 / ZÜRICH',
    coord:'47°22′37″ N / 8°32′30″ E'
  },
  {
    at:.73, title:ui.garage_title, sub:ui.garage_sub, label:'04 / UNDERGROUND', coord:'ZÜRICH / AFTER DARK'
  },
  {
    at:.96,
    title:ui.car_title,
    sub:ui.car_sub,
    label:'05 / DEIN AUTO',
    coord:'DESTINATION / YOUR DRIVE'
  }
];

const accent=[
  '166,184,183',
  '210,73,48',
  '174,185,193',
  '199,181,148',
  '230,131,56',
  '185,190,202',
  '152,102,204',
  '84,151,105',
  '208,163,79',
  '84,147,199'
];

let reduced=matchMedia('(prefers-reduced-motion: reduce)').matches;

try{
  const saved=sessionStorage.getItem('sd-motion');
  if(saved!==null)reduced=saved==='reduced';
}catch{}

let target=0;
let current=0;
let targetGallery=0;
let currentGallery=0;
let raf=0;
let chapterIndex=-1;
let productIndex=-1;
let earth=null;
let prevTime=0;
let drawnJourney=-1;
let drawnGallery=-1;
let galleryPinState="";
let galleryHeight=0;
let galleryWidth=0;

const metrics={
  w:innerWidth,
  h:innerHeight,
  jStart:0,
  jRange:1,
  gStart:0,
  gRange:1
};

const vehicleCatalog=JSON.parse(root.querySelector('[data-sd4d-vehicles]').textContent);
const vehicles=products.map(p=>vehicleCatalog.find(v=>p.url.endsWith('/'+v.handle)));
const vehicleScreen=$('vehicleScreen');
const carImages=vehicles.map(v=>{const img=new Image();img.alt='';img.decoding='async';img.className='vehicle-photo';vehicleScreen.append(img);return img;});
let flight=null;
let flightBusy=false;
let pendingVehicle=-1;
let vehicleToken=0;
let galleryVisible=false;
const interiorCord=$("interiorCord");
let sceneTurns=[];
const cards=[];
const dots=[];

products.forEach((p,i)=>{
  const card=$('productStage').querySelectorAll('.edition')[i];
  cards.push(card);

  const dot=document.createElement('button');
  dot.type='button';
  dot.setAttribute('aria-label',p.name+' '+ui.show);
  dot.onclick=()=>scrollGallery(i);

  $('editionDots').append(dot);
  dots.push(dot);
});

function measure(){
  if(!galleryHeight||galleryWidth!==innerWidth){
    galleryWidth=innerWidth;
    galleryHeight=Math.round(viewport.offsetHeight);
    gallery.style.setProperty('--sd-gallery-height',galleryHeight+'px');
    gallery.style.setProperty('--sd-gallery-travel',(galleryHeight*11)+'px');
  }
  metrics.w=innerWidth;
  metrics.h=viewport.offsetHeight;
  metrics.jStart=journey.getBoundingClientRect().top+scrollY;
  metrics.jRange=Math.max(1,journey.offsetHeight-metrics.h);
  metrics.gStart=gallery.getBoundingClientRect().top+scrollY;
  metrics.gRange=Math.max(1,gallery.offsetHeight-galleryView.offsetHeight);

  earth?.resize();
  readScroll();
}

function updateGalleryPin(){
  const y=scrollY-metrics.gStart;
  const state=reduced?'static':y<0?'before':y>metrics.gRange?'after':'fixed';
  if(state!==galleryPinState){galleryPinState=state;gallery.dataset.pin=state;}
}
function readScroll(){
  updateGalleryPin();
  target=reduced?0:clamp((scrollY-metrics.jStart)/metrics.jRange);

  targetGallery=reduced?0:
    clamp((scrollY-metrics.gStart)/metrics.gRange)*(products.length-1);
  galleryVisible=scrollY>metrics.gStart-metrics.h*.4&&scrollY<metrics.gStart+metrics.gRange+metrics.h;
  if(galleryVisible&&productIndex<0)drawnGallery=-1;

  schedule();
}

function schedule(){
  if(!raf){
    prevTime=0;
    raf=requestAnimationFrame(tick);
  }
}

function opacity(id,v){
  $(id).style.opacity=clamp(v).toFixed(4);
}

function interpolateFrames(frames,p){
  let i=0;

  while(i<frames.length-2&&p>frames[i+1][0])i++;

  const a=frames[i];
  const b=frames[i+1];
  const t=smooth(a[0],b[0],p);

  return a.slice(1).map((v,k)=>lerp(v,b[k+1],t));
}

function renderJourney(p){
  const mobile=metrics.w<=640;

  opacity('space',1-smooth(.27,.37,p));
  const earthReveal=smooth(.06,.14,p);
  $('earthCanvas').style.opacity=root.classList.contains('webgl-ready')?earthReveal:0;
  root.querySelector('.earth-fallback').style.opacity=root.classList.contains('webgl-ready')?0:earthReveal;

  opacity(
    'swissScene',
    smooth(.27,.37,p)*(1-smooth(.46,.55,p))
  );

  opacity('cityScene',smooth(.46,.55,p)*(1-smooth(.64,.70,p)));
  opacity('flightLogo',1-smooth(.79,.87,p));

  opacity(
    'windowScene',
    smooth(.64,.70,p)*(1-smooth(.79,.85,p))
  );

  opacity('cockpitScene',smooth(.80,.88,p));

  const mapZoom=lerp(.9,6.7,smooth(.36,.55,p));

  $('swissMap').style.transform=
    `scale(${mapZoom}) rotate(${lerp(-8,0,smooth(.27,.45,p))}deg)`;

  $('cityPhoto').style.transform=
    `scale(${lerp(1,2.2,smooth(.49,.95,p))}) translateY(${lerp(0,-4,smooth(.55,1,p))}%)`;

  const carZoom=lerp(1,1.35,smooth(.64,.85,p));

  $('carWindow').style.transform=
    `scale(${carZoom}) rotateY(${lerp(-12,0,smooth(.65,.8,p))}deg)`;

  $('cockpitScene').style.transform=
    `scale(${lerp(1.2,1,smooth(.81,.96,p))})`;

  const flash=
    Math.sin(Math.PI*clamp((p-.29)/.13))*.58+
    Math.sin(Math.PI*clamp((p-.78)/.09))*.23;

  opacity('atmosphere',flash);

  const frames=mobile
    ? [
        [0,64,29,.75,-8,-14],
        [.12,62,32,.60,-3,-10],
        [.25,56,36,.15,0,0],
        [.36,57,31,.12,0,0],
        [.5,53,38,.18,0,-5],
        [.64,52,39,.30,2,-9],
        [.76,50,38,.52,0,6],
        [.90,56,35,.75,0,0],
        [1,56,35,.75,0,0]
      ]
    : [
        [0,69,44,1,-8,-14],
        [.12,66,41,.72,-3,-8],
        [.25,56,37,.16,0,0],
        [.36,57,35,.12,0,0],
        [.5,53,43,.18,0,-5],
        [.64,52,43,.34,2,-9],
        [.76,50,39,.55,0,6],
        [.90,56,37,.67,0,0],
        [1,56,37,.67,0,0]
      ];

  const [x,y,scale,rz,ry]=interpolateFrames(frames,p);

  $('flightLogo').style.left=x+'%';
  $('flightLogo').style.top=y+'%';

  $('flightLogo').style.transform=
    `translate(-50%,-50%) perspective(900px) rotateY(${ry}deg) rotateZ(${rz}deg) scale(${scale})`;

  const first=1-smooth(.055,.16,p);

  opacity('initialCopy',first);

  $('initialCopy').style.transform=
    `translateY(${-smooth(.05,.16,p)*35}px)`;

  $('initialCopy').style.visibility=
    first<.01?'hidden':'visible';

  let ci=p<.27?0:p<.48?1:p<.67?2:p<.87?3:4;

  if(ci!==chapterIndex){
    chapterIndex=ci;
    const c=chapters[ci];

    // KORREKTUR: Keine sichtbaren <br>-Zeichen mehr
    $('chapterTitle').textContent=cleanChapterText(c.title);
    $('chapterSubtitle').textContent=cleanChapterText(c.sub);

    $('chapterEyebrow').textContent=c.label;
    $('coordinate').textContent=c.coord;

    $('sceneNumber').innerHTML=
      String(ci+1).padStart(2,'0')+' <span>/ 05</span>';

    root.querySelectorAll('[data-chapter]').forEach((b,i)=>{
      b.classList.toggle('active',i===ci);

      if(i===ci){
        b.setAttribute('aria-current','step');
      }else{
        b.removeAttribute('aria-current');
      }
    });
  }

  const copyOpacity=
    ci===1
      ? smooth(.30,.37,p)*(1-smooth(.43,.48,p))
      : ci===2
      ? smooth(.50,.56,p)*(1-smooth(.65,.73,p))
      : ci===3
      ? smooth(.68,.72,p)*(1-smooth(.79,.85,p))
      : ci===4
      ? smooth(.90,.96,p)
      : 0;

  opacity('chapterCopy',copyOpacity);

  $('chapterCopy').style.transform=
    `translateY(${(1-copyOpacity)*20}px)`;

  $('journeyProgress').style.transform=`scaleX(${p})`;

  $('scrollLabel').textContent=
    p>.92?ui.continue:ui.scroll;

  if(earth&&p<.39)earth.render(p);
}

function prepareCrest(card){
  if(card.dataset.rasterReady)return Promise.resolve();
  if(card._rasterPromise)return card._rasterPromise;
  card._rasterPromise=new Promise(resolve=>{
    const svg=card.querySelector('.floating-crest');
    const source=svg.querySelector('image');
    const img=new Image();
    img.onload=()=>{
      try{
        const box=svg.viewBox.baseVal;
        const canvas=document.createElement('canvas');
        const ratio=Math.min(1,720/box.width);
        canvas.width=Math.round(box.width*ratio);canvas.height=Math.round(box.height*ratio);
        const ctx=canvas.getContext('2d');ctx.scale(ratio,ratio);ctx.translate(-box.x,-box.y);
        ctx.clip(new Path2D(svg.querySelector('path').getAttribute('d')));
        ctx.drawImage(img,0,0,900,Number(source.getAttribute('height')));
        canvas.className='crest-bitmap';canvas.setAttribute('aria-hidden','true');
        svg.after(canvas);svg.style.display='none';card.dataset.rasterReady='true';
      }catch{}
      resolve();
    };
    img.onerror=resolve;img.src=source.getAttribute('href');
  });
  return card._rasterPromise;
}
function preloadVehicle(i){
  if(i<0||i>=vehicles.length||!vehicles[i])return;
  const image=carImages[i];if(!image.src)image.src=vehicles[i].src;
  prepareCrest(cards[i]);
}
function flightTransform(x,y,scale){return `translate3d(${x}px,${y}px,0) translate(-50%,-50%) scale(${scale})`;}
async function showVehicle(index){
  if(reduced||!vehicles[index])return;
  if(flightBusy){pendingVehicle=index;return;}
  const token=++vehicleToken;
  flightBusy=true;pendingVehicle=-1;
  preloadVehicle(index);
  await Promise.all([prepareCrest(cards[index]),carImages[index].decode().catch(()=>{})]);
  if(token!==vehicleToken||reduced)return;
  const card=cards[index];
  const previous=productIndex;
  let direction=previous<0||index>previous?1:-1;
  if(previous===vehicles.length-1&&index===0)direction=1;
  if(previous===0&&index===vehicles.length-1)direction=-1;
  flight?.cancel();
  sceneTurns.forEach(a=>a.cancel());sceneTurns=[];
  interiorCord.style.opacity='0';
  cards.forEach((c,i)=>{c.style.visibility=i===index?'visible':'hidden';c.style.opacity=i===index?'1':'0';});
  carImages.forEach((img,i)=>img.classList.toggle('is-active',i===index));
  const perspective=Math.max(650,galleryView.clientWidth);
  const turn=(x,angle,z)=>`perspective(${perspective}px) translate3d(${x}%,0,${z}px) rotateY(${angle}deg)`;
  if(previous>=0&&previous!==index){
    const old=carImages[previous];old.style.zIndex='1';
    sceneTurns.push(old.animate([
      {transform:turn(0,0,0),opacity:1},
      {transform:turn(-direction*32,direction*36,-100),opacity:.75,offset:.55},
      {transform:turn(-direction*75,direction*65,-240),opacity:0}
    ],{duration:950,easing:'cubic-bezier(.22,.61,.36,1)'}));
  }
  const entering=carImages[index];entering.style.zIndex='2';
  sceneTurns.push(entering.animate([
    {transform:turn(direction*75,-direction*65,-240),opacity:0},
    {transform:turn(direction*32,-direction*36,-100),opacity:.8,offset:.45},
    {transform:turn(0,0,0),opacity:1}
  ],{duration:1100,easing:'cubic-bezier(.22,.61,.36,1)'}));
  productIndex=index;
  const product=products[index];
  $('productTitle').textContent=product.name;$('productLink').href=product.url;
  $('productPrice').textContent=product.priceText;$('galleryCount').textContent=String(index+1).padStart(2,'0');
  $('vehicleName').textContent=vehicles[index].name;
  gallery.style.setProperty('--accent',accent[index]);
  dots.forEach((d,i)=>{d.classList.toggle('active',i===index);d.setAttribute('aria-pressed',String(i===index));});
  const w=galleryView.clientWidth,h=galleryView.clientHeight;
  const scene=vehicleScreen.getBoundingClientRect();
  const scale=Math.min(scene.width/1672,scene.height/941);
  const tx=(scene.width-1672*scale)/2+vehicles[index].target[0]*1672*scale;
  const mirrorY=vehicleScreen.offsetTop+(scene.height-941*scale)/2+vehicles[index].target[1]*941*scale;
  const small=w<=640;
  const landingHeight=Math.max(46,Math.min(110,941*scale*.19));
  const cordLength=Math.max(10,941*scale*.04);
  const ty=mirrorY+cordLength+landingHeight/2;
  const landingScale=landingHeight/card.offsetHeight;
  const showcaseX=w*(small?.5:.69),showcaseY=h*(small?.39:.45);
  const finish=flightTransform(tx,ty,landingScale);
  interiorCord.style.left=tx+'px';interiorCord.style.top=mirrorY+'px';interiorCord.style.height=cordLength+'px';
  card.style.transform=finish;
  flight=card.animate([
    {transform:flightTransform(w*(direction>0?1.2:-.2),h*.38,.65),opacity:0,offset:0},
    {transform:flightTransform(w*(direction>0?1.2:-.2),h*.38,.65),opacity:0,offset:.24},
    {transform:flightTransform(showcaseX,showcaseY,1),opacity:1,offset:.46},
    {transform:flightTransform(showcaseX,showcaseY,1),opacity:1,offset:.63},
    {transform:flightTransform((showcaseX+tx)/2,Math.min(showcaseY,ty)-h*.04,.65),opacity:1,offset:.82},
    {transform:finish,opacity:1,offset:1}
  ],{duration:3000,easing:'cubic-bezier(.22,.61,.36,1)',fill:'forwards'});
  flight.finished.catch(()=>{}).then(()=>{
    if(token!==vehicleToken)return;
    flightBusy=false;
    interiorCord.style.opacity='1';
    const next=pendingVehicle;pendingVehicle=-1;
    if(next>=0&&next!==productIndex&&galleryVisible)showVehicle(next);
  });
  preloadVehicle(index+1);
}
function renderGallery(u){
  if(reduced){
    ++vehicleToken;flight?.cancel();flightBusy=false;pendingVehicle=-1;
    cards.forEach(c=>{c.style.visibility='visible';c.style.opacity='1';c.style.transform='none';});
    sceneTurns.forEach(a=>a.cancel());
    interiorCord.style.opacity='0';
    carImages.forEach(img=>img.classList.remove('is-active'));
    productIndex=-1;return;
  }
  if(!galleryVisible)return;
  const index=Math.round(u);
  if(productIndex<0){showVehicle(index);return;}
  const difference=u-productIndex;
  if(Math.abs(difference)>.68&&index!==productIndex)showVehicle(index);
}
$('previousVehicle').onclick=()=>scrollGallery((productIndex-1+products.length)%products.length);
$('nextVehicle').onclick=()=>scrollGallery((productIndex+1)%products.length);
preloadVehicle(0);

function tick(time){
  raf=0;

  const dt=Math.min(64,time-(prevTime||time-16));
  prevTime=time;

  const damping=1-Math.exp(-dt/130);

  current=lerp(
    current,
    target,
    reduced?1:damping
  );

  currentGallery=targetGallery;

  if(Math.abs(current-target)<.00005)current=target;

  if(Math.abs(currentGallery-targetGallery)<.0005){
    currentGallery=targetGallery;
  }

  if(current!==drawnJourney){renderJourney(current);drawnJourney=current;}
  if(currentGallery!==drawnGallery){renderGallery(currentGallery);drawnGallery=currentGallery;}

  if(current!==target||currentGallery!==targetGallery){
    raf=requestAnimationFrame(tick);
  }else{prevTime=0;}
}

function jump(y){
  window.scrollTo({
    top:y,
    behavior:reduced?'instant':'smooth'
  });
}

function scrollGallery(i){
  const top=metrics.gStart+i/Math.max(1,products.length-1)*metrics.gRange;
  window.scrollTo({top,behavior:'instant'});
  galleryVisible=true;
  showVehicle(i);
}

root.querySelectorAll('[data-chapter]').forEach(b=>{
  b.onclick=()=>jump(
    metrics.jStart+
    chapters[Number(b.dataset.chapter)].at*metrics.jRange
  );
});

$('restart').onclick=()=>jump(0);

function applyMotion(){
  root.classList.toggle('still',reduced);

  $('motionToggle').textContent=
    reduced?ui.activate:ui.reduce;

  $('motionToggle').setAttribute(
    'aria-pressed',
    String(reduced)
  );

  cards.forEach(c=>{
    c.querySelector('.edition-frame').tabIndex=
      reduced?0:-1;

    c.querySelector('.static-caption').tabIndex=
      reduced?0:-1;
  });

  measure();

  current=target;
  currentGallery=targetGallery;

  renderJourney(current);
  renderGallery(currentGallery);
}

$('motionToggle').onclick=()=>{
  reduced=!reduced;

  try{
    sessionStorage.setItem(
      'sd-motion',
      reduced?'reduced':'full'
    );
  }catch{}

  drawnGallery=-1;
  productIndex=-1;
  applyMotion();
  jump(0);
};

window.addEventListener(
  'scroll',
  readScroll,
  {passive:true}
);

let timer;

window.addEventListener(
  'resize',
  ()=>{
    if(innerWidth===metrics.w)return;
    clearTimeout(timer);

    timer=setTimeout(()=>{
      productIndex=-1;
      drawnJourney=-1;
      drawnGallery=-1;
      measure();
    },120);
  },
  {passive:true}
);

document.addEventListener(
  'visibilitychange',
  ()=>{
    if(!document.hidden){
      prevTime=0;
      readScroll();
    }
  }
);

applyMotion();

import(root.dataset.earthModule)
  .then(m=>m.createEarth(
    $('earthCanvas'),
    {textureUrl:root.dataset.earthTexture}
  ))
  .then(e=>{
    earth=e;
    root.classList.add('webgl-ready');
    earth.render(current);
    drawnJourney=-1;
    schedule();
  })
  .catch(()=>{
    root.classList.add('webgl-fallback');
  });

window.addEventListener('load',measure,{once:true});
}

if(document.readyState==='loading'){
  document.addEventListener(
    'DOMContentLoaded',
    initializeScratchDriveJourney,
    {once:true}
  );
}else{
  initializeScratchDriveJourney();
}

document.addEventListener(
  'shopify:section:load',
  initializeScratchDriveJourney
);




